import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const HourGlassButton = ({ ...props }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <span
      className="tw-cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <FontAwesomeIcon
        icon={isHovered ? "fa-solid fa-xmark" : "fa-solid fa-hourglass-end"}
      />
    </span>
  );
};

export default HourGlassButton;
